const qs = require('qs')
const { showError } = require('../../libs/helper')

module.exports = {
  getDetail: (g, params) => {
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/bmd/detail`,
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      console.log(err)
    })
    return result
  },

  getDataBmd: (g, params) => {
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/bmd/list-register`,
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },

  getDataBmdPendalamanPendataan: (g, params) => {
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/pendataan/list`,
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },

  submitPengajuan: async (g, data) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/bmd/submit-pengajuan`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Submit Form')
    })
    return result
  },

  validasiP3b: async (g, data) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/bmd/validasi/p3b`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Submit Form')
    })
    return result
  },

  validasiKepala: async (g, data) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/bmd/validasi/kepala`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Submit Form')
    })
    return result
  },
}
